// Modules
import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import html2canvas from "html2canvas";
import RangeSlider from "react-bootstrap-range-slider";
import { AuthContext } from "../../../Context/AuthContext";
import jwt_decode from "jwt-decode";
import MP3Player from "../../Common/MP3Player/MP3Player";
// Styles
import Styles from "./Styles/SinglePage.module.css";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
// Components
import Header from "../../Common/Header/Header";
import BookDetails from "../../Common/BookDetails/BookDetails";
import Comment from "../../Common/Comment/Comment";
import Footer from "../../Common/Footer/Footer";
import DownloadCard from "../../Common/downloadCard/DownloadCard";
// Images
import rateImage from "../../../Assets/Icons/rate.png";
import viewSinglePageImage from "../../../Assets/Icons/viewSinglePage.png";
import timeImage from "../../../Assets/Icons/time.png";
import alphabetImage from "../../../Assets/Icons/alphabet.png";
import subjectImage from "../../../Assets/Icons/subject.png";
import heartImage from "../../../Assets/Icons/black-heart.png";
import writerIcon from "../../../Assets/Icons/writer.png";
import translatorIcon from "../../../Assets/Icons/translator.png";
import cancelImage from "../../../Assets/Icons/cancel-dark.png";
import copyImage from "../../../Assets/Icons/copy-dark.png";
import noteTakingImage from "../../../Assets/Icons/note-taking.png";
import highlightImage from "../../../Assets/Icons/highlight-dark.png";
import blueHeartImage from "../../../Assets/Icons/blue-heart.png";
// API
import { getSingleArticle } from "../../../Services/getData";
import {
  createComment,
  createView,
  createViewUnauth,
  likePost,
  sendArticleInteresting,
  // updateUser,
} from "../../../Services/usersService";
import { getItem } from "../../../Services/storage";

const SinglePage = () => {
  const {
    isLoggedIn,
    login,
    // logout
  } = useContext(AuthContext);
  const { id } = useParams();
  const history = useHistory();
  const textRef = useRef();
  const [commentSendTimer, setCommentSendTimer] = useState(0);
  const [commentSended, setCommentSended] = useState(false);
  const [selectedText, setSelectedText] = useState(null);
  const [rangeValue, setRangeValue] = useState(100);
  const [userInterestingSended, setUserInterestingSended] = useState(false);
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });
  const [showPopover, setShowPopover] = useState(false);
  const [helpTextIsActive, setHelpTextIsActive] = useState(false);
  const textDownloadRef = useRef();
  const [commentText, setCommentText] = useState("");
  const [postIsLiked, setPostIsLiked] = useState(false);
  // const [text, setText] = useState("");
  const [pageData, setPageData] = useState({
    content: "",
  });
  // const [createViewCounter, setCreateViewCounter] = useState(30);

  // const [token, setToken] = useState();
  const token = getItem("token");
  const [decodedToken, setDecodedToken] = useState();
  // const [subscriptionStatus, setSubscriptionStatus] = useState([]);

  // useEffect(() => {
  //   if (!isLoggedIn) {
  //     return history.replace("/users/login");
  //   }
  // }, [history, isLoggedIn]);

  // useEffect(() => {
  //   const api = async () => {
  //     try {
  //       const { data } = await updateUser();
  //       login(data.token);
  //       setToken(data.token);
  //     } catch (ex) {
  //       toast.error(ex.response.data.message);
  //     }
  //   };
  //   api();
  // }, [login,isLoggedIn]);

  // useEffect(() => {
  //   if (createViewCounter !== 0) {
  //     const interval = setInterval(() => {
  //       setCreateViewCounter((prev) => prev - 1);
  //     }, 1000);
  //     return () => clearInterval(interval);
  //   }
  // }, [createViewCounter]);

  useEffect(() => {
    if (commentSendTimer !== 0) {
      const sendCommentTimerInterval = setInterval(() => {
        setCommentSendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(sendCommentTimerInterval);
    }
  }, [commentSendTimer]);

  useEffect(() => {
    if (token) {
      setDecodedToken(jwt_decode(token));
      // setSubscriptionStatus(jwt_decode(token).user.subscriptionStatus);
    }
  }, [token]);

  useEffect(() => {
    const api = async () => {
      try {
        const { data } = await getSingleArticle(id);
        const likedArticle = data.article.likes.users.findIndex(
          (i) => i.userId === decodedToken?.user.userId
        );
        if (likedArticle !== -1) {
          setPostIsLiked(true);
        }
        const rangeSliderSended = data.article.userRate.find(
          (i) => i.userId === decodedToken?.user.userId
        );
        if (rangeSliderSended !== undefined) {
          setRangeValue(rangeSliderSended.rate);
          setUserInterestingSended(true);
        }
        setPageData(data.article);
      } catch (ex) {
        toast.error(ex.response.data.message);
      }
    };
    if (id) {
      api();
    }
  }, [id, commentSended, decodedToken]);

  useEffect(() => {
    const api = async () => {
      try {
        if (isLoggedIn) {
          const result = await createView({ type: "article", id });
          if (result.data.token) {
            login(result.data.token);
            const copyPageData = { ...pageData };
            copyPageData.views.count = copyPageData.views.count + 1;
            setPageData(copyPageData);
          }
        } else {
          await createViewUnauth({ type: "article", id });
        }
      } catch (ex) {
        if (ex.response) {
          toast.error(ex.response.data.message);
        } else {
          console.log(ex);
        }
      }
    };
    // if (
    //   isLoggedIn &&
    //   (decodedToken?.user.subscriptionStatus[0]?.have ||
    //     decodedToken?.user.subscriptionStatus[1]?.have ||
    //     decodedToken?.user.monthlyFreeArticleView < 3) &&
    //   createViewCounter === 0
    // ) {
    api();
    // }
  }, [
    isLoggedIn,
    id,
    decodedToken,
    login,
    //  createViewCounter
  ]);

  useEffect(() => {
    if (!selectedText) {
      setShowPopover(false);
    }
  }, [selectedText]);

  //* copy text handler
  document.addEventListener("copy", function (event) {
    const customText = "مرجع : سایت هرمه";

    const copiedText = window.getSelection().toString() + " | " + customText;

    event.clipboardData.setData("text/plain", copiedText);

    event.preventDefault();
  });

  const handleCopyText = () => {
    const customText = "مرجع : سایت هرمه";
    const copiedText = selectedText + " | " + customText;
    navigator.clipboard
      .writeText(copiedText)
      .then(() => {
        toast.success("متن با موفقیت کپی شد");
        setShowPopover(false);
      })
      .catch((error) => {
        console.error("خطا در کپی متن:", error);
      });
  };

  //* download text handler
  const handleDownloadSelectedText = () => {
    // if (isLoggedIn) {
    html2canvas(textDownloadRef.current).then((canvas) => {
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "card.png";
      link.click();
      setShowPopover(false);
    });
    // } else {
    //   toast.error("برای فیش برداری لطفا ابتدا وارد حساب کاربری خود شوید");
    // }
  };

  const handleTextSelection = () => {
    const selection = window.getSelection();

    const selected = selection.toString();

    if (selected) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();

      setPopoverPosition({
        top: rect.top + window.scrollY,
        left: rect.right + window.scrollX,
      });

      if (!selection.isCollapsed) {
        setSelectedText(selected);
      } else {
        const word = selection.anchorNode.textContent;
        const start = selection.anchorOffset;
        const end = selection.extentOffset;
        const selectedWord = word.slice(
          Math.min(start, end),
          Math.max(start, end)
        );
        setSelectedText(selectedWord);
        range.collapse(start < end);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      setShowPopover(true);
    } else {
      setShowPopover(false);
    }
  };

  //* handle highlight
  const handleHighlightText = () => {
    // if (isLoggedIn) {
    if (selectedText) {
      if (selectedText.length > 4) {
        if (window.getSelection().focusNode.parentElement.nodeName !== "SPAN") {
          const regex = new RegExp(selectedText, "g");
          const newPageData = { ...pageData };
          const coloredContent = newPageData.content.replace(
            regex,
            `<span style="background-color: #7fff00;">${selectedText}</span>`
          );
          newPageData.content = coloredContent;
          setPageData(newPageData);
          setShowPopover(false);
        } else {
          toast.error("متن هایلایت شده را نمیتوانید هایلایت کنید!");
        }
      } else {
        toast.error("کلمه انتخابی نباید کمتر از 4 کاراکتر باشد");
      }
    }
    // } else {
    //   toast.error("برای هایلایت لطفا ابتدا وارد حساب کاربری خود شوید");
    // }
  };

  const deleteHighlight = () => {
    if (selectedText) {
      if (window.getSelection().focusNode.parentElement.nodeName === "SPAN") {
        const newPageData = { ...pageData };
        const coloredContent = newPageData.content.replace(
          window.getSelection().focusNode.parentElement.outerHTML,
          window.getSelection().focusNode.parentElement.innerHTML
        );
        newPageData.content = coloredContent;
        setShowPopover(false);
        setPageData(newPageData);
      }
    }
  };

  const sendComment = (comment) => {
    if (!isLoggedIn) {
      toast.error("برای نظردهی ابتدا باید وارد حساب کاربری خود شوید");
      return;
    }
    if (comment.length === 0) {
      toast.error("لطفا ابتدا یک متن وارد کنید");
      return;
    }
    if (commentSendTimer === 0) {
      const data = {
        comment,
        userId: decodedToken.user.userId,
        id: pageData._id,
        kind: "article",
      };
      toast.promise(createComment(data), {
        loading: "درحال ارسال نظر شما . . .",
        success: (res) => {
          setCommentSended((prev) => !prev);
          setCommentText("");
          setCommentSendTimer(60);
          return res.data.message;
        },
        error: (res) => res.data.message,
      });
    } else {
      toast.error(
        `لطفا ${convertSpecificNumbersToPersian(
          commentSendTimer.toString()
        )} ثانیه بعد کامنت بعدی خود را ارسال کنید`
      );
    }
  };

  //* convert Numbers To Persian
  function convertNumbersToPersian(text) {
    const persianNumbers = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
    };
    return persianNumbers[text];

    // return text.replace(/[0-9]/g, function (match) {
    //   return persianNumbers[match];
    // });
  }
  function convertSpecificNumbersToPersian(text) {
    const persianNumbers = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
    };

    return text.replace(/[0-9]/g, function (match) {
      return persianNumbers[match];
    });
  }

  function updateLinksNames(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const aTags = doc.querySelectorAll("a");
    aTags.forEach((aTag) => {
      const hrefValue = aTag.getAttribute("href");
      const match = hrefValue.match(/#_ftn([0-9۰-۹]+)/);
      const matchEnd = hrefValue.match(/#_ftnref([0-9۰-۹]+)/);
      if (match) {
        const number = match[1];
        const nameValue = `_ftnref${number}`;
        aTag.setAttribute("name", nameValue);
      } else if (matchEnd) {
        const number = matchEnd[1];
        const nameValue = `_ftn${number}`;
        aTag.setAttribute("name", nameValue);
        aTag.setAttribute("class", "styledATagRefferedToText");
      }
    });

    const updatedHtml = new XMLSerializer().serializeToString(doc);
    return updatedHtml;
  }

  function convertLinksToPersianNumber(input) {
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

    const result = input.replace(/\[([0-9۰-۹]+)\]/g, (_, number) => {
      const persianNumber = Array.from(
        String(number),
        (digit) => persianDigits[parseInt(digit, 10)] || digit
      ).join("");
      return persianNumber;
    });
    return result;
  }

  const handleLikePost = () => {
    if (isLoggedIn) {
      const data = { type: "article", id: pageData._id };
      toast.promise(likePost(data), {
        loading: "درحال اجرای عملیات . . .",
        success: (res) => {
          setPageData((prev) => {
            const updatedPrev = { ...prev };

            updatedPrev.likes.users.push({ userId: decodedToken.user.userId });

            return updatedPrev;
          });
          setPostIsLiked(true);
          return res.data.message;
        },
        error: (res) => res.response.data.message,
      });
    } else {
      toast.error("برای پسندیدن لطفا وارد حساب کاربری خود شوید");
    }
  };

  const handleSendArticleInteresting = () => {
    if (isLoggedIn) {
      const data = { feel: rangeValue, articleId: pageData._id };
      toast.promise(sendArticleInteresting(data), {
        loading: "درحال ارسال نظرسنجی شما . . .",
        success: (res) => {
          setPageData((prev) => {
            const updatedPrev = { ...prev };

            updatedPrev.userRate.push({
              rate: rangeValue,
              userId: decodedToken.user.userId,
            });

            return updatedPrev;
          });
          setUserInterestingSended(true);
          return res.data.message;
        },
        error: (res) => res.response.data.message,
      });
    } else {
      toast.error("برای ارسال نظر لطفا وارد حساب کاربری خود شوید");
    }
  };

  return (
    <div className={Styles.container}>
      <Toaster />
      {/* Header */}
      <Header />
      {/* download text */}
      {selectedText?.length > 0 && (
        <div
          style={{
            position: "absolute",
            zIndex: -10,
            right: 100000,
            top: -10000,
          }}
        >
          <DownloadCard
            bookName={pageData.title}
            pageNumber={null}
            text={selectedText}
            writerName={pageData.writer}
            translatorName={pageData.translator}
            ref={textDownloadRef}
          />
        </div>
      )}
      {/* Content */}
      <div className={Styles.content}>
        <div className={Styles.newDetailsDesign}>
          <img
            className={Styles.postImage}
            src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${pageData.image}`}
            alt=""
          />
          <div className={Styles.imageMask}></div>
          <div className={Styles.otherDetails}>
            <div className={Styles.titleContainerNewDesign}>
              <div className={Styles.textContainer}>
                <h2>{pageData.title}</h2>
                {pageData.kind === "textual" && (
                  <>
                    <h4>
                      <img src={writerIcon} alt="" />
                      {pageData.writer}
                    </h4>
                    <h4>
                      <img src={translatorIcon} alt="" /> {pageData.translator}
                    </h4>
                  </>
                )}
              </div>
              {/* <div className={`${Styles.textContainer} ${Styles.englishText}`}>
                <h2>{pageData.title}</h2>
                <h4>{pageData.writer}</h4>
                <h4>
                  <img src="" alt="" /> {pageData.translator}
                </h4>
              </div> */}
            </div>
            <img
              className={Styles.responsivePostImage}
              src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${pageData.image}`}
              alt=""
            />
            <div className={Styles.options}>
              {pageData.kind === "textual" && (
                <h3
                  className={
                    helpTextIsActive ? Styles.activeTextHelp : Styles.textHelp
                  }
                  onClick={() =>
                    // subscriptionStatus.length > 0 ||
                    // decodedToken?.user.monthlyFreeArticleView < 3
                    //   ? setHelpTextIsActive((prev) => !prev)
                    //   : toast.error(
                    //       "برای استفاده از قابلیتهای سایت باید اشتراک تهیه کنید"
                    //     )
                    setHelpTextIsActive((prev) => !prev)
                  }
                >
                  راهنمای متن
                </h3>
              )}
              <div className={Styles.rateContainer}>
                <div className={Styles.imageContainer}>
                  <img src={rateImage} alt="" />
                </div>
                <div className={Styles.separator}></div>
                <h4>
                  {pageData.rate ? convertNumbersToPersian(pageData.rate) : "۰"}
                </h4>
              </div>
              <Link to="/" className={Styles.download}>
                <p>دانلود</p>
              </Link>
            </div>
            <div className={Styles.bottom}>
              {/* Time */}
              <BookDetails
                icon={timeImage}
                title1="زمان"
                title2="مطالعه"
                detail={`${pageData.readingTime} دقیقه`}
              />
              {/* Count */}
              {pageData.kind === "textual" && (
                <BookDetails
                  icon={alphabetImage}
                  title1="تعداد"
                  title2="کلمات"
                  detail={pageData.wordsCount}
                />
              )}
              {/* Subject */}
              <BookDetails
                icon={subjectImage}
                title1="کلان"
                title2="موضوع"
                detail={pageData.bigTopic}
              />
              {/* View */}
              <BookDetails
                icon={viewSinglePageImage}
                title1="تعداد"
                title2="بازدید"
                view={pageData.views?.count}
              />
            </div>
          </div>
        </div>
        {pageData.kind === "textual" && (
          <>
            <div className={Styles.contentDetails}>
              <div className={Styles.imageContainer}>
                <img
                  src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${pageData.originSiteLogo}`}
                  alt=""
                />
              </div>
              {/* {cedodedToken.user.haveSubscribtion && pageData.audio && ( */}
              {/* <audio controls>
            <source
              src={`http://localhost:5000/uploads/images/${pageData.audio}`}
              type="audio/mpeg"
            />
          </audio> */}
              {
                // ((subscriptionStatus.length > 0 &&
                //   (subscriptionStatus[0]?.imageOrTextual === "textual" ||
                //     subscriptionStatus[1]?.imageOrTextual === "textual")) ||
                //   decodedToken?.user.monthlyFreeArticleView < 3) &&
                pageData.audio && (
                  <MP3Player
                    audioFile={`${process.env.REACT_APP_PUBLIC_PATH}uploads/audios/${pageData.audio}`}
                  />
                )
              }
              {
                // ((subscriptionStatus.length > 0 &&
                //   (subscriptionStatus[0]?.imageOrTextual === "textual" ||
                //     subscriptionStatus[1]?.imageOrTextual === "textual")) ||
                //   decodedToken?.user.monthlyFreeArticleView < 3) &&
                !pageData.audio && (
                  <h2 className={Styles.audioNotAccess}>
                    در حال حاضر نسخه صوتی مقاله موجود نمیباشد
                  </h2>
                )
              }
              {/* {subscriptionStatus.length === 0 &&
                decodedToken?.user.monthlyFreeArticleView > 2 && (
                  <h2 className={Styles.audioNotAccess}>
                    برای استفاده از نسخه صوتی مقاله لطفا اشتراک تهیه کنید
                  </h2>
                )} */}
              {/* {!isLoggedIn && (
                <h2 className={Styles.audioNotAccess}>
                  برای استفاده از نسخه صوتی مقاله لطفا وارد حساب کاربری خود شوید
                </h2>
              )} */}
              {/* )} */}
            </div>
            <p className={Styles.shortDescriptionForOriginalSite}>
              {pageData.underOriginSiteLogoDesc}
            </p>
          </>
        )}
        <p className={Styles.shortDescription}></p>
        {pageData.kind === "textual" ? (
          <div
            className={Styles.postTextContainer}
            onMouseUp={handleTextSelection}
          >
            <p
              className={helpTextIsActive ? Styles.hoveredText : {}}
              onMouseUp={deleteHighlight}
              onCopy={(event) => event.preventDefault()}
              dangerouslySetInnerHTML={{
                __html: convertLinksToPersianNumber(
                  updateLinksNames(pageData.content)
                ),
                // isLoggedIn &&
                // ((subscriptionStatus.length > 0 &&
                //   (subscriptionStatus[0]?.imageOrTextual === "textual" ||
                //     subscriptionStatus[1]?.imageOrTextual === "textual")) ||
                //   decodedToken?.user.monthlyFreeArticleView < 3)
                //   ? convertLinksToPersianNumber(
                //       updateLinksNames(pageData.content)
                //     )
                //   : pageData.testContent,
              }}
              ref={textRef}
            ></p>
            {
              // (subscriptionStatus.length === 0 ||
              //   typeof decodedToken?.user.monthlyFreeArticleView ===
              //     "undefined")
              // (subscriptionStatus.length > 0 &&
              //   (subscriptionStatus[0]?.imageOrTextual === "textual" ||
              //     subscriptionStatus[1]?.imageOrTextual === "textual")) ||
              // decodedToken?.user.monthlyFreeArticleView < 3 ? (
              //   <></>
              // ) : (
              //   <>
              //     <div className={Styles.hideText}></div>
              //     {isLoggedIn ? (
              //       <button
              //         onClick={() => {
              //           history.replace("../../users/panel/cart");
              //         }}
              //       >
              //         برای خواندن ادامه مطالب اشتراک تهیه کنید
              //       </button>
              //     ) : (
              //       <button
              //         onClick={() => {
              //           history.replace("../../users/login");
              //         }}
              //       >
              //         برای خواندن ادامه مطالب وارد حساب خود شوید
              //       </button>
              //     )}
              //   </>
              // )
              // (
              //   <>
              //     <div className={Styles.hideText}></div>
              //     <button>
              //       برای خواندن ادامه مطالب{" "}
              //       {isLoggedIn ? "اشتراک تهیه کنید" : "وارد حساب خود شوید"}
              //     </button>
              //   </>
              // )
            }
            {/* <div className={Styles.suggestedPost}>
            <p>مطلب پیشنهادی</p>
          </div> */}
            {pageData.keyWords?.length > 0 && (
              // isLoggedIn &&
              // ((subscriptionStatus.length > 0 &&
              //   (subscriptionStatus[0]?.imageOrTextual === "textual" ||
              //     subscriptionStatus[1]?.imageOrTextual === "textual")) ||
              //   decodedToken?.user.monthlyFreeArticleView < 3) && (
              //   <div className={Styles.keyWordsContainer}>
              //     <h3>کلید واژه ها :</h3>
              //     <div className={Styles.keyWords}>
              //       {pageData.keyWords.map((item, index) => (
              //         <h4 key={index}>{item}</h4>
              //       ))}
              //     </div>
              //   </div>
              // )
              <div className={Styles.keyWordsContainer}>
                <h3>کلید واژه ها :</h3>
                <div className={Styles.keyWords}>
                  {pageData.keyWords.map((item, index) => (
                    <h4 key={index}>{item}</h4>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          pageData.video?.length > 0 && (
            // isLoggedIn &&
            // ((subscriptionStatus.length > 0 &&
            //   (subscriptionStatus[0]?.imageOrTextual === "image" ||
            //     subscriptionStatus[1]?.imageOrTextual === "image")) ||
            //   decodedToken?.user.monthlyFreeArticleView < 3) &&
            <video
              className={Styles.PostVideo}
              style={{ padding: "15px", height: "600px" }}
              controls
            >
              <source
                src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/videos/${pageData.video}`}
                type="video/mp4"
              />
              مرورگر شما این ویدیو را پشتیبانی نمیکند
            </video>
          )
        )}
        {/* {isLoggedIn &&
          (subscriptionStatus.length > 0 ||
            decodedToken?.user.monthlyFreeArticleView < 3)
             && ( */}
        <div className={Styles.rangeSlider}>
          <img
            onClick={handleLikePost}
            className={Styles.likePost}
            src={postIsLiked ? blueHeartImage : heartImage}
            alt=""
          />
          <button
            disabled={userInterestingSended}
            onClick={handleSendArticleInteresting}
          >
            ثبت
          </button>
          <RangeSlider
            tooltip="on"
            className={Styles.range}
            value={rangeValue}
            disabled={userInterestingSended}
            onChange={(changeEvent) => setRangeValue(changeEvent.target.value)}
          />
          <h3>: میزان رضایتمندی شما از این مطلب</h3>
        </div>
        {/* )} */}
        <div className={Styles.commentsContainer}>
          {pageData.comments?.length > 0 ? (
            pageData.comments.map((item, index) => (
              <Comment
                username={item.username}
                comment={item.comment}
                key={index}
              />
            ))
          ) : (
            <h2 style={{ marginBottom: "25px", color: "#4b495b" }}>
              دیدگاهی وجود ندارد
            </h2>
          )}
          <div className={Styles.sendComment}>
            <div className={Styles.textContainer}>
              <textarea
                placeholder="دیدگاه خود را اینجا بنویسید . . ."
                name="comment"
                id="comment"
                cols="30"
                rows="10"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              ></textarea>
              <div className={Styles.title}>
                <h3>دیدگاه</h3>
                <h3>شما</h3>
              </div>
            </div>
            <div className={Styles.sendContainer}>
              <div
                className={Styles.send}
                style={{ textAlign: "center", width: "85.5%" }}
                onClick={() => sendComment(commentText)}
              >
                ثبت
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.footer}>
          <Footer />
        </div>
        <div
          style={{
            border: "1px solid transparent",
          }}
        ></div>
      </div>
      {showPopover && (
        // isLoggedIn &&
        // (decodedToken?.user.haveSubscribtion ||
        //   decodedToken?.user.monthlyFreeArticleView < 3) &&
        <ul
          className={Styles.popup}
          style={{
            position: "absolute",
            top: popoverPosition.top,
          }}
        >
          <li onClick={() => setShowPopover(false)}>
            <img src={cancelImage} alt="" />
            <p>لغو</p>
          </li>
          <li onClick={handleDownloadSelectedText}>
            <img src={noteTakingImage} alt="" />
            <p>فیش برداری</p>
          </li>
          <li onClick={handleCopyText}>
            <img src={copyImage} alt="" />
            <p>کپی</p>
          </li>
          <li onClick={handleHighlightText}>
            <img src={highlightImage} alt="" />
            <p>هایلایت</p>
          </li>
        </ul>
      )}
    </div>
  );
};

export default SinglePage;
